
import {submitForm} from 'public/submitForm.js';

// Colin: This event occurs when the user clicks the 'Free Consultation' button.
export function formSubmitButton_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	// Kai may want additional conditions on formFilled (e.g. Organization !== "", and maybe Question !== ""). 
	
	var formFilled = $w('#inputName').value !== "" && $w('#inputEmail').value !== "" && $w('#inputCompany').value !== "";

	if (formFilled) {
		// Remember to change currentpage string
		// Colin: Call the public function, passing through all the desired form data.
		// Wix has some code in the background to "listen" for when this event occurs. If we end up moving away from the Wix platform, we may need to add this code in directly.
		var currentPage = "home"; 
		var newsletterDecline = !$w('#checkboxForm').checked;
		// console.log("newsletterDecline: " + newsletterDecline);
		submitForm($w("#inputName").value, $w("#inputCompany").value, $w("#inputEmail").value, $w("#inputPhone").value, $w("#textBox1").value, currentPage, newsletterDecline).then(function(r) {
        formSubmissionMessage(r);
    });
		// console.log("Hello");
	} else {
		$w('#textConsultFormResponse').text = "Please provide a name, organization, and email address.";
		// $w('#textConsultFormResponse').show();
	}
		$w('#textConsultFormResponse').show();
}

// Colin: This function is intended to let the user know what happened to their form submission.
export function formSubmissionMessage(submissionStatus) {
    // console.log('Submission status matches success?: ' + 'success' === submissionStatus);
    if ('error' === submissionStatus) {
        $w('#textConsultFormResponse').text = 'Submission failed.';
        // $w('#textConsultFormResponse').hidden = false;
        // console.log('Submission message changed to fail.');
    } else {
        $w('#textConsultFormResponse').text = "We'll find a solution for you shortly!";
        // $w('#textConsultFormResponse').hidden = false;
        // console.log('Submission message changed to success.');
    }
}